import request from '@/utils/request'

// 用户注册
export const register = (data) => {
  const mobile = data.mobile || data.phone
  const registerData = {
    mobile,
    phone: mobile,
    password: data.password,
    captcha: data.captcha,
    username: data.username || (mobile ? `user_${String(mobile).slice(-6)}` : '')
  }
  return request({
    url: '/user/register',
    method: 'post',
    data: registerData
  })
}

// 用户登录
export const login = (data) => {
  // 将 phone 转换为 account 参数
  const loginData = {
    account: data.phone || data.mobile || data.account,
    password: data.password
  }
  return request({
    url: '/user/login',
    method: 'post',
    data: loginData
  })
}

// 获取图形验证码
export const getCaptcha = () => {
  return request({
    url: '/user/captcha',
    method: 'get'
  })
}

// 发送短信验证码
export const sendSmsCode = (data) => {
  return request({
    url: '/user/sms-code',
    method: 'post',
    data
  })
}

// 退出登录
export const logout = () => {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 获取用户信息
export const getUserProfile = () => {
  return request({
    url: '/user/profile',
    method: 'get'
  })
}

// 更新用户信息
export const updateUserProfile = (data) => {
  return request({
    url: '/user/profile',
    method: 'put',
    data
  })
}

// 修改密码
export const changePassword = (data) => {
  return request({
    url: '/user/password',
    method: 'put',
    data
  })
}

// 获取地址列表
export const getAddressList = () => {
  return request({
    url: '/user/addresses',
    method: 'get'
  })
}

// 添加地址
export const addAddress = (data) => {
  return request({
    url: '/user/addresses',
    method: 'post',
    data
  })
}

// 更新地址
export const updateAddress = (id, data) => {
  return request({
    url: `/user/addresses/${id}`,
    method: 'put',
    data
  })
}

// 删除地址
export const deleteAddress = (id) => {
  return request({
    url: `/user/addresses/${id}`,
    method: 'delete'
  })
}

// 获取我的收藏
export const getCollections = (params) => {
  return request({
    url: '/user/collections',
    method: 'get',
    params
  })
}

// 获取浏览历史
export const getHistory = (params) => {
  return request({
    url: '/user/history',
    method: 'get',
    params
  })
}

// 获取我的发布
export const getMyPublish = (params) => {
  return request({
    url: '/user/publish',
    method: 'get',
    params
  })
}

// 获取我的寻根
export const getMyRootSeeking = (params) => {
  return request({
    url: '/user/root-seeking',
    method: 'get',
    params
  })
}

// 获取消息列表
export const getMessages = (params) => {
  return request({
    url: '/user/messages',
    method: 'get',
    params
  })
}

// 标记消息已读
export const markMessageRead = (id) => {
  return request({
    url: `/user/messages/${id}/read`,
    method: 'put'
  })
}

// 删除消息
export const deleteMessage = (id) => {
  return request({
    url: `/user/messages/${id}`,
    method: 'delete'
  })
}
